const DEFAULT_AUTH_REDIRECT = '/hub';
const REDIRECT_BLACKLIST = new Set([
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/setup-password',
  '/verify-email',
  '/session/setup-2fa',
  '/session/verify-2fa',
]);

export const getSafeAuthRedirectUrl = (
  callbackUrl: string | string[] | undefined | null,
  fallback = DEFAULT_AUTH_REDIRECT
) => {
  const rawCallbackUrl = Array.isArray(callbackUrl)
    ? callbackUrl[0]
    : callbackUrl;

  if (!rawCallbackUrl) return fallback;

  try {
    // make sure raw url points to the same website url
    const url = new URL(rawCallbackUrl, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;

    // Exclude Auth Pages to be redirectable via query params to prevent login flow loop
    if (REDIRECT_BLACKLIST.has(url.pathname)) return fallback;

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
};

export const syncSafeAuthCallbackUrlCookie = (
  callbackUrl: string | string[] | undefined | null,
  fallback = DEFAULT_AUTH_REDIRECT
) => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return fallback;
  }

  const safePath = getSafeAuthRedirectUrl(callbackUrl, fallback);
  const safeUrl = new URL(safePath, window.location.origin).toString();
  const isSecure = window.location.protocol === 'https:';
  const cookieName = isSecure
    ? '__Secure-next-auth.callback-url'
    : 'next-auth.callback-url';
  const secure = isSecure ? '; Secure' : '';

  document.cookie = `${cookieName}=${encodeURIComponent(safeUrl)}; Path=/; SameSite=Lax${secure}`;

  return safePath;
};
